export default {
	routes: {
		home: {
			path: '/',
			name: 'home',
		},

		networkMap: {
			path: '/network-map/',
			name: 'networkMap',
			pagePad: true,
		},

		chargingOffering: {
			path: '/charging-offering/',
			name: 'chargingOffering',
			pagePad: true,
		},

		depotFeatures: {
			path: '/depot-features/',
			name: 'depotFeatures',
			pagePad: true,
		},

		truckLeasing: {
			path: '/truck-leasing/',
			name: 'truckLeasing',
			pagePad: true,
		},

		project: {
			path: '/project/',
			name: 'project',
			pagePad: true,
		},

		climateUnitedLease: {
			path: '/climate-united-lease/',
			name: 'climateUnitedLease',
			pagePad: true,
		},

		marketAccelerationProgram: {
			path: '/market-acceleration-program/',
			name: 'marketAccelerationProgram',
			pagePad: true,
		},

		beneficialCargoOwners: {
			path: '/beneficial-cargo-owners/',
			name: 'beneficialCargoOwners',
			pagePad: true,
		},

		news: {
			path: '/news/',
			name: 'news',
			pagePad: true,
		},

		contactUs: {
			path: '/contact-us/',
			name: 'contactUs',
			pagePad: true,
		},

		termsAndConditions: {
			path: '/terms-and-conditions/',
			name: 'termsAndConditions',
			pagePad: true,
		},
		privacyPolicy: {
			path: '/privacy-policy/',
			name: 'privacyPolicy',
			pagePad: true,
		},

		aboutUs: {
			path: '/about-us/',
			name: 'aboutUs',
			pagePad: true,
		},
		notFound: {
			path: '/not-found/',
			name: 'notFound',
			pagePad: true,
		},
	},
};
